import { PromotionList } from '../components/PromotionList';
import { PageHeading } from '@/components/ui/PageHeading';

export function PromotionsPage() {
  return (
    <div className="py-2">
      <PageHeading
        kind="gem"
        eyebrow="Topluluğa özel"
        title="Promosyonlar"
        description="Gee Family topluluğuna özel bonus kodları ve kampanyalar. Tek bir yerde, tüm fırsatlar."
      />

      <div className="mt-8">
        <PromotionList skeletonCount={6} />
      </div>

      <p className="mt-10 text-xs leading-relaxed text-surface-600">
        18+. Kumar bağımlılık yapabilir. Sorumlu oyun oynayın. Bonus şartları siteye göre değişir;
        çevrim şartlarını okumadan yatırım yapmayın. Bu sayfadaki bağlantılar ortaklık
        bağlantısıdır.
      </p>
    </div>
  );
}
